import * as React from 'react';

import { connect } from 'react-redux';

import ListPackagesView from '../../views/library/list-packages.view';
import { IPackageListingAppState } from '../../redux-state';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IPerformanceGroup, IPackage } from '../../custom/classes/production';

interface IListPackagesExternalProps {
}

interface StateToProps {
    packages: Array<IPackage>;
    text: IPackageListingAppText;
}

export type ListPackagesProps = IListPackagesExternalProps & StateToProps;

export class ListPackagesBase extends React.Component<ListPackagesProps, any> {
    render() {
        return (
            <ListPackagesView {...this.props} />
        )
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListPackagesExternalProps): StateToProps {
    return {
        packages: state.packageListing.packages,
        text: state.packageListingText
    }
}

export default connect<StateToProps>(mapStateToProps)(ListPackagesBase);